import { postTagManager } from '../api/tagManager';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const mergePersons = async ({ personIds, targetPersonId }, logger) => {
    const urlParams = new URLSearchParams();
    personIds.length && personIds.map((personId) => urlParams.append('personIds', personId));
    return postTagManager(urlParams, `person/${targetPersonId}/merge`, {}, logger);
};
